/* *****************************    Customerbase DTO    ***************************** */
export interface CustomerSearchFilters {
    cbCustomerId?: string | null,
    bpCode?: string | null,
    taxCode?: string | null,
    vatNumber?: string | null,
    drvLicenceNumber?: string | null,
    lastName?: string | null,
    firstName?: string | null,
    email?: string | null,
    customerType?: string | null,
    role?: any[] | null,
    vip?: string | null,
    partnerType?: string | null,
    businessName?: string | null,
    dossierStatus?: string | null,
    digitalIdentity?: boolean | null,
    digitalIdentityStatus?: string | null,
    dossierOrigin?: string | null
}

export interface CustomerSearchDataPagination {
    filters: CustomerSearchFilters,
    orderBy?: string | null,
    orderDir?: string | null,
    start?: number | null,
    limit?: number | null

}

export interface CBPersonalInfo {
    firstName?: string,
    lastName?: string,
    vatNumber?: string,
    taxCode?: string,
    drvLicenceNumber?: string,
    gender?: string,
    birthDate?: string,
    birthCountry?: string,
    birthProvince?: string,
    birthCity?: string,
    vatNumberCountry?: string,
    businessName?: string,
    siren?: string,
    siret?: string
}

export interface CBAddress {
    id?: string
    cbCustomerId?: string,
    addressNumber?: string,
    street?: string,
    houseNumber?: string,
    zipCode?: string,
    province?: string,
    city?: string,
    country?: string,
    addrEmail?: string,
    pec?: string,
    addrMobile?: string,
    telephone?: string,
    fax?: string,
    website?: string,
    companyFiscalCode?: string,
    recipientCode?: string,
    addressType?: string
}

export interface CBExtraAddress {
    division?: string,
    idAssociation?: string,
    customerId?: string,
    bpCode?: string,
    businessName?: string,
    vatNumber?: string
    firstName?: string,
    lastName?: string,
    taxCode?: string,
    addressNumber?: string,
    street?: string,
    houseNumber?: string,
    zipCode?: string,
    province?: string,
    city?: string,
    country?: string,
    addrEmail?: string,
    pec?: string,
    addrMobile?: string,
    telephone?: string,
    fax?: string,
    website?: string,
    companyFiscalCode?: string,
    recipientCode?: string,
    addressType?: string,
    product?: string,
    productDetail?: string,
    registration?: string
}

export interface CBContactDetails {
    prefix?: string,
    mobile?: string,
    addresses?: CBAddress[]
}

export interface CBTermsAndCondition {
    id?: string,
    companyCode?: string,
    termCondType?: string,
    result?: boolean,
    division?: string,
    communicationChannel?: string,
    distributionChannel?: string,
    revocationChannel?: string,
    revocationReason?: string,
    acquisitionDateTime?: string,
    revocationDateTime?: string
}

export interface CBSalesAreaAppData {
    id?: string,
    salesOrganization?: string,
    distributionChannel?: string,
    division?: string,
    currency?: string
}

export interface CBPaymentInfo {
    id?: string,
    buagId?: string,
    buagClass?: string,
    paymentMethod?: string,
    paymentTerms?: string,
    correspondingVariant?: string,
    iban?: string,
    accountHolder?: string,
    referenceDetails?: string
}

export interface CBCorporateContactPerson {
    id?: string,
    cbCustomerId?: string,
    bpCode?: string,
    name?: string,
    surname?: string,
    address?: string,
    houseNumber?: string,
    country?: string,
    region?: string,
    city?: string,
    postalCode?: string,
    phoneNumber?: string,
    mobile?: string,
    email?: string,
    delete?: string
}

export interface CBCorporateInfo {
    idZIT019?: string,
    salesArea?: string,
    fleet?: string,
    class?: string,
    sizingClass?: string,
    maxRentalNum?: string,
    contactPersons?: CBCorporateContactPerson[]
}

export interface CBDocuments {
    kind?: string,
    idNumber?: string,
    issueDate?: string,
    expireDate?: string,
    issuingAuthority?: string,
    category?: string,
    mctcStatus?: string,
    mctcStatusCode?: string,
    mctcStatusMessage?: string,
    mctcValidationStatusTime?: string
}

export interface CBBusinessLine {
    description?: string,
    status?: string
}

export interface CBRegistryPhase {
    phaseType?: string,
    phaseCaption?: string,
    verify?: boolean,
    customerId?: string | null,
    subState?: string
}

export interface CBDossiers {
    idDossier?: string,
    title?: string,
    description?: string,
    creationTime?: string,
    updateTime?: string,
    identifier?: string,
    customerId?: string,
    status?: string,
    origin?: string

}

export interface CBBundleAttachment {
    idBundleAttach?: string,
    cbCustomerId?: string,
    valid?: boolean,
    kind?: string;
    frontSidePage?: string,
    backSidePage?: string,
    type?: string,
    idNumber?: string,
    validFrom?: string,
    validTo?: string,
    responsibleInstitution?: string,
    category?: string,
    idBundle?: string
}

export interface CBBundle {
    idBundle?: string,
    uuidBundle?: string,
    valid?: boolean,
    country?: string,
    cbCustomerId?: string,
    status?: string,
    creationDate?: string,
    attachments?: CBBundleAttachment[]
}

export interface CustomerBaseDto {
    cbCustomerId: string,
    bpCode: string,
    idTenant: string,
    oldBpCode: string,
    email?: string,
    cbType: string,
    dealerType?: string,
    customerType?: string,
    role?: string[],
    language: string,
    partnerType: string,
    vip?: string,
    blacklist?: string,
    blacklistDescription?: string,
    initialRegDate?: string,
    finalRegDate?: string,
    legalForm?: string,
    publicAuthority: string,
    paIdNumber?: string,
    bpBlocked?: string,
    idpUid?: string,
    customerState?: string,
    cfValidated?: string,
    registry?: CBPersonalInfo,
    contactInfo?: CBContactDetails,
    termsAndCond?: CBTermsAndCondition[],
    salesAreas?: CBSalesAreaAppData[],
    paymentInfo?: CBPaymentInfo[],
    corporateInfo?: CBCorporateInfo,
    documents?: CBDocuments[],
    businessLines?: CBBusinessLine[],
    registryPhases?: CBRegistryPhase[],
    linkedAddresses?: CBExtraAddress[],
    dossiers?: CBDossiers[],
    bundles?: CBBundle[],
    digitalIdentityStatus?: string,
    extMgmtReason?: string,
    csData?: CarSharingData
}

export interface CheckFCRequest {
    firstName: string,
    lastName: string,
    gender: string,
    birthDate: string,
    birthProvince?: string,
    birthCity: string,
    taxCode: string
}

export interface ICustomer {
    //customerId: string,
    firstName: string,
    lastName: string,
    birthDate: string,
    birthProvince: string,
    birthCity: string,
    residenceCountry: string,
    taxCode: string,
    email: string,
    mobile: string,
    drvLicenseNumber: string,
}

export interface LinkCustomerData {
    division?: string,
    bpCode?: string | null,
    customerId?: string | null,
    bpCodeToLink?: string | null,
    customerIdToLink?: string | null,
    product?: string | null,
    productDetail?: string | null
}

/* *****************************    Dossier DTO    ***************************** */

export interface FieldType {
    description: string,
    name: string,
    tags: string[],
    title: string,
    type: string,
    values: string[]
}

export interface AttachmentType {
    description: string,
    fields: FieldType[],
    identifier: string,
    kind: string,
    pages: string[],
    tags: string[],
    title: string
}

export interface DossierTemplateDto {
    identifier: string,
    title: string,
    description: string,
    attachments: AttachmentType[],
    fields: FieldType[],
    tags: string[]
}

export interface Field {
    attachment: string,
    dossier: string,
    owner: string,
    type: FieldType,
    value: string,
    values: string[]
}

export interface Page {
    attachment: string,
    creationTime: string,
    dossier: string,
    note: string,
    origin: string,
    originIdentifier: string,
    owner: string,
    status: string,
    type: string,
    updateTime: string
}

export interface Attachment {
    country: string,
    creationTime: string,
    description: string,
    dossier: string,
    expireDate: string,
    fields: Field[],
    identifier: string,
    issueDate: string,
    note: string,
    number: string,
    origin: string,
    originIdentifier: string,
    owner: string,
    pages: Page[],
    status: string,
    title: string,
    type: AttachmentType,
    updateTime: string
}

export interface DossierDto {
    identifier: string,
    owner: string,
    title: string,
    description: string,
    attachments: Attachment[],
    fields: Field[],
    creationTime: string,
    updateTime: string,
    note: string,
    origin: string,
    originIdentifier: string,
    status: string,
    template: string
}

interface IBundleDocInfo {
    kind: string | null,
    type: string | null,
    firstName: string | null,
    lastName: string | null,
    dateOfBirth: string | null,
    idDocument: string | null,
    issueDate: string | null,
    expireDate: string | null,
    birthMunicipality: string | null,
    birthProvince: string | null,
    licenseCategory: string | null,
    releasedBy: string | null,
    placeOfIssue: string | null
}

export interface IBundleInfoValues {
    step?: string | null,
    ocrInfo?: IBundleDocInfo | null,
    usrInfo?: IBundleDocInfo | null,
}

export interface BundleStatusResponse {
    uuid?: string,
    data: IBundleInfoValues[]
}

/* *****************************    Forms    ***************************** */
export interface IFormValues {
    cbDetails: {
        cbCustomerId: string,
        bpCode: string,
        idTenant: string,
        oldBpCode: string,
        email: string,
        mobilePrefix: string,
        mobile: string,
        cbType: string,
        role: string[],
        language: string,
        partnerType: string,
        vip: string,
        blacklist: string,
        blacklistDescription: string,
        initialRegistrationDate: string,
        finalRegistrationDate: string,
        bpBlocked: string,
        idpUid: string,
        customerState: string,
        digitalIdentityStatus: string,
        extMgmtReason: string
    },
    cbPersonalInfo: {
        firstName: string,
        lastName: string,
        gender: string,
        birthDate: string,
        birthCountry: string,
        birthProvince: string,
        birthCity: string,
        drvLicenceNumber: string,
        vatNumber: string,
        vatNumberCountry: string,
        businessName: string,
        taxCode: string,
        residenceAddressId?: string | null,
        residenceCbCustomerId?: string | null,
        residenceAddressNumber?: string | null,
        residenceStreet: string,
        residenceHouseNumber: string,
        residenceZipCode: string,
        residenceProvince: string,
        residenceCity: string,
        residenceCountry: string,
        residenceAddressType: string,
        legalForm: string,
        dealerType: string,
        customerType: string,
        publicAuthority: string,
        paIdNumber: string,
        cfValidated: string,
        siren: string,
        siret: string
    },
    cbInvoicingAddress: {
        invoicingAddressId?: string | null,
        invoicingCbCustomerId?: string | null,
        invoicingAddressNumber?: string | null,
        invoicingStreet: string,
        invoicingHouseNumber: string,
        invoicingZipCode: string,
        invoicingProvince: string,
        invoicingCity: string,
        invoicingCountry: string,
        invoicingAddrEmail: string,
        invoicingPec: string,
        invoicingAddrMobile: string,
        invoicingTelephone: string,
        invoicingFax: string,
        invoicingWebsite: string,
        invoicingCompanyFiscalCode: string,
        invoicingRecipientCode: string,
        invoicingAddressType: string
    }/*,
    cbContacts: {
        addresses: {
            id?: string | null,
            cbCustomerId?: string | null,
            addressNumber?: string | null,
            street: string,
            houseNumber: string,
            zipCode: string,
            province: string,
            city: string,
            country: string,
            addrEmail: string,
            pec: string,
            addrMobile: string,
            telephone: string,
            fax: string,
            website: string,
            companyFiscalCode: string,
            recipientCode: string,
            addressType: string
        }[]
    },*/
    termsAndConditions: {
        id?: string | null,
        companyCode?: string | null,
        termCondType: string,
        result: boolean | null,
        division: string,
        communicationChannel: string,
        distributionChannel: string,
        revocationChannel: string,
        revocationReason: string,
        acquisitionDateTime: string,
        revocationDateTime: string
    }[],
    salesAreas: {
        id?: string | null,
        salesOrganization: string,
        distributionChannel: string,
        division: string,
        currency: string
    }[],
    cbPaymentInfo: {
        id?: string | null,
        buagId?: string | null,
        buagClass: string,
        paymentMethod: string,
        paymentTerms: string,
        correspondingVariant: string,
        iban: string,
        accountHolder: string,
        referenceDetails: string
    }[],
    cbCorporateInfo: {
        idZIT019?: string | null,
        salesArea: string,
        fleet: string,
        class: string,
        sizingClass: string,
        maxRentalNum: string,
        contactPersons: {
            id?: string | null,
            //cbCustomerId?: string | null,
            bpCode?: string | null,
            name: string,
            surname: string,
            address: string,
            houseNumber: string,
            country: string,
            region: string,
            city: string,
            postalCode: string,
            phoneNumber: string,
            mobile: string,
            email: string,
            delete: string
        }[]
    }/*,
    cbDocuments: {
        idNumber: string | null,
        kind: string | null,
        issueDate: string | null,
        expireDate: string | null,
        issuingAuthority: string | null,
        category: string | null,
        mctcStatus: string | null,
        mctcStatusCode: string | null,
        mctcStatusMessage: string | null,
        mctcValidationStatusTime: string | null,
        frontPage: File | null
    }[],*/
    /*cbDossier: {
        owner: string | null,
        identifier: string | null,
        template: string | null,
        status: string | null,
        attachments: {
            owner: string | null,
            dossier: string | null,
            identifier: string | null,
            number: string | null,
            kind: string | null,
            status: string | null,
            issueDate: string | null,
            expireDate: string | null,
            country: string | null,
            frontPage: File | null,
            backPage: File | null
        }[]
    },*/
    cbConsents: {
        id?: string | null,
        companyCode?: string | null,
        termCondType: string,
        result: boolean | null,
        division: string,
        communicationChannel: string,
        distributionChannel: string,
        revocationChannel: string,
        revocationReason: string,
        acquisitionDateTime: string,
        revocationDateTime: string
    }[],
    cbRegistryPhases: {
        customerId?: string | null,
        phaseType: string,
        phaseCaption: string,
        verify: boolean,
        subState: string
    }[],
    cbDossiers: {
        idDossier?: string | null,
        customerId?: string | null,
        title: string,
        description: string,
        creationTime: string,
        updateTime: string,
        identifier: string,
        status: string,
        origin: string
    }[],
    cbBundles: {
        idBundle?: string | null,
        uuid?: string | null,
        country?: string
    }[],
    cbExtraAddresses: {
        idAssociation?: string | null,
        customerId?: string | null,
        bpCode?: string | null,
        division: string,
        businessName: string,
        vatNumber: string,
        firstName: string,
        lastName: string,
        taxCode: string,
        addressNumber?: string | null,
        street: string,
        houseNumber: string,
        zipCode: string,
        province: string,
        city: string,
        country: string,
        addrEmail: string,
        pec: string,
        addrMobile: string,
        telephone: string,
        fax: string,
        website: string,
        companyFiscalCode: string,
        recipientCode: string,
        addressType: string,
        product: string,
        productDetail: string,
        registration: string
    }[],
    csData: CarSharingData;
}

export interface CarSharingData {
    id?: number;
    csCustomerId?: number;
    cbCustomerId?: number;
    modPersonId?: number;
    sku?: string;
    createdAt?: string;
    updatedAt?: string;
    migratedAt?: string;
    pin?: string;
    idSelectedCity?: number;
    billingCbCustomerId?: number;
}

export interface CarSharingDataResponse {
    carSharingData: CarSharingData;
}

export interface OmooveModData {
  PState: number;
  city: string;
  contractData: ContractData[];
  countryCodeID: number;
  countryCodeName: string;
  customerNumber: string;
  dateOfBirth: string;
  dealerships: null;
  firstName: string;
  governmentNumber: string | null;
  hasToChangePwd: string;
  houseNumber: string;
  invites: any[]; // TODO: definire interfaccia
  keyword: string;
  languageID: number;
  lastName: string;
  mail: string;
  mobilePhone: string;
  modifyAllowed: boolean;
  monitored: number;
  myCityId: number;
  personID: number;
  personTypeID: number;
  salutationID: number;
  stateProvince: string;
  street: string;
  suspendedResponses: SuspendedResponse[];
  userProfileData: UserProfileData;
  userRentKeyDatas: UserRentKeyData[];
  zipCode: string;
}

export interface ContractData {
  amountActualBalance: number;
  childInfo: null;
  contractDetailsData: ContractDetailsData;
  contractID: number;
  contractNumber: string;
  contractStateID: number;
  contractTypeID: number;
  contractTypeName: string;
  contractUser: null;
  listaCityInfo: ListaCityInfo[];
  isOwner: boolean;
}

export interface ContractDetailsData {
  city: string;
  contractUsers: any[]; // TODO: definire interfaccia
  contractValidityEndDate: string;
  contractValidityStartDate: string;
  country: string;
  dateOfPaymentID: number;
  houseNumber: string;
  minBillingAmount: number;
  numberOfContractUsers: number;
  street: string;
  wayOfPaymentTypeID: number;
  zipCode: string;
}

export interface ListaCityInfo {
  moaId: number;
  moaName: string;
}

export interface SuspendedResponse {
  code: string;
  messageLanguages: MessageLanguage[];
  suspendedDate: string;
}

export interface MessageLanguage {
  languageId: number;
  message: string;
  state: string;
}

export interface UserProfileData {
  alternativeParking: any[]; // TODO: definire interfaccia
  favoriteParking: FavoriteParking;
}

export interface FavoriteParking {
  cityID: number;
  parkingID: number;
}

export interface UserRentKeyData {
  authorizationFault: number;
  deviceDetails: string;
  deviceType: number;
  incomingInteropData: boolean;
  interopAllowed: boolean;
  isInteropAllowed: boolean;
  operationType: number;
  rentKeyNr: string;
  rentKeyState: number;
  rentKeyTypeID: number;
  validFrom: string;
  validTill: string;
}

export interface OmooveModDataResponse extends OmooveModData {
  additionalMessage: string | null;
  httpCode: number;
  httpStatus: string;
}


export interface OmooveCustomerData {
  address: OmooveAddress;
  anagraphicComplete: boolean;
  authentications: any[]; 
  birthCity: string;
  birthCountry: string;
  birthCountryId: number | null;
  birthProvince: string;
  birthZoneId: number | null;
  contracts: unknown | null;
  customerId: number;
  customerNumber: number;
  customerPaymentLogs: any[]; 
  customerPaymentMethodLogs: any[];
  customerPendingDatas: any[];
  dateOfBirth: string; 
  dateUpdate: string; 
  dealerId: number | null;
  denyRequest: unknown | null;
  drivingLicenses: any[];
  email: string;
  emailUpdateError: string | null;
  emailUpdated: string | null;
  fleet: boolean;
  gender: number;
  guest: number;
  houseNumber: string | null;
  idCountry: number;
  idLanguage: number;
  idSelectedCity: number;
  idZone: number;
  idpUserId: string;
  market: string;
  masterId: number;
  mobilePhone: string;
  name: string;
  prefix: string | null;
  providerId: number;
  pwd: string;
  recoveryAddUser: number;
  referenceDate: number;
  regSmsCode: string;
  regSmsCodes: OmooveRegSmsCode[];
  registrationCode: string | null;
  registrationStatus: number;
  rentKeys: any[];
  rulesStatus: number;
  street: string | null;
  surname: string;
  taxCode: string | null;
  type: string;
  validityStatus: number;
  zipCode: string | null;
}

export interface OmooveBillData {
  address: OmooveAddress;
  company: string;
  companyFiscalCode: string;
  idBillingAddress: number;
  idBillingCity: number;
  idCountry: number;
  idCustomer: number;
  idZone: number;
  pec: string;
  recipientCode: string;
  vatNumber: string;
  vatNumberCountry: string;
}

export interface OmooveAddress {
  cap: string | null;
  cbCustomer: number;
  city: string;
  country: string;
  houseNumber: string | null;
  idAddress: number;
  province: string;
  street: string | null;
}

export interface OmooveRegSmsCode {
  codeSent: string;
  codeSentDate: string;
  codeValidationDate: string | null;
  customerId: number;
  idRegSmsCode: number;
  registrationEvent: boolean;
}

export interface OmooveCustomerResponse {
  additionalMessage: string | null;
  body: {
    bill: OmooveBillData;
    checkDocumentData: unknown | null;
    customer: OmooveCustomerData;
    dossier: unknown | null;
    payment: unknown | null;
    rentkey: unknown | null;
  };
  httpCode: number;
  httpStatus: string;
}




export interface CarSharingSubscription {
    id: number,
    subType: number,
    description: string,
    contractId: string,
    personId: number,
    customerId: number,
    dailyUsedMinutes: number,
    dailyUsedReservations: number,
    monthlyUsedMinutes: number,
    monthlyUsedMinutesDef: number,
    activationDate: string,
    expiringDate: string,
    renewIndex: number,
    enableRenew: number,
    classification: string,
    actionType: string,
    nextMonthlyRenew: string,
    creationSubscriptionDate: string,
    updateSubscriptionDate: string,
    expiryDateSubscription: string,
    switchRequestIsPresent: boolean
}

export interface LocationData {
    address: string;
    lat: number;
    lon: number;
    referencedate?: string | null;
}

export interface LocationDataEnd {
    address: string;
    lat: number;
    lon: number;
}
export interface CarSharingReservation {

    arrivalParking: string;
    arrivalParkingGroupID: number;
    arrivalParkingID: number;
    bcCapability: number;
    carCategoryID: number;
    carIdentifier: string;
    carName: string;
    carPlate: string;
    city: string;
    contractID: number;
    customerNumber: string;
    deltaTimeUserActionState: number;
    departureParking: string;
    departureParkingGroupID: number;
    departureParkingID: number;
    doorsOpened: boolean;
    enabledTermRental: boolean;
    firstName: string;
    fuelLevel: number;
    grossPrice: number;
    isFreeFloating: boolean;
    lastExecutedCommand: number;
    lastName: string;
    locationData: LocationData;
    locationDataEnd: LocationDataEnd;
    personID: number;
    releaseControlDatas: string[]; // da controllare il tipo
    releaseStatus: number;
    remainingAttempt: number;
    rentalTypeID: number;
    reservationActionDatas: string[]; // da controllare il tipo
    reservationDistance?: number;
    reservationDuration: number;
    reservationEndDate: string;
    reservationID: number;
    reservationPrice: number;
    reservationStartDate: string;
    reservationStateId: number;
    reservationSubStateId: number;
    reserveAndPickup: boolean;
    userActionStateId: number;
    virtualRentalID: number;
    virtualRentalTypeID: number;
    monitored: number;
    intoPolygon: boolean;
    referenceDate: string;
    hasBatterySmartKeyAlarm: boolean;
    hasDisconnectedSmartKeyAlarm: boolean;
}

interface ReservationCustomerData {
    contractIdList: string[];
    personID: number;
    personStateID: number;
    personTypeId: number;
}

interface ReservationDate {
    day: number;
    month: number;
    year: number;
    hour: number;
    minute: number;
    second: number;
    timezone: number;
}

interface Arg0 {
    reservationCustomerData: ReservationCustomerData;
    startDate: ReservationDate;
    endDate: ReservationDate;
}

interface RetrieveReservationHistoryService {
    arg0: Arg0;
}

export interface ReservationHistoryRequest {
    retrieveReservationHistoryService: RetrieveReservationHistoryService;
}

export interface GetReservationHistoryParams{
    personId: number;
    contractId: number;
    startDate?: string;
    endDate?: string;
}


export interface CarSharingSuspension {
    personId: number;
    personName: string;
    assistentId: number;
    assistentName: string;
    creationDate: string;
    plannedShow: boolean;
    suspendedDate: string;
    suspendedStatus: string;
    suspendedType: number;
    suspendedTypeName: string;
    suspendedTypeDesc: string;
    note: string;
    languageId: number;
    caption: string;
    historyAssistentId: number;
}

export interface ActiveSuspension extends CarSharingSuspension { }

export interface HistorySuspension extends CarSharingSuspension {
    historyDate: string;
    historyAssistentId: number;
    historyNote: string;
}

export interface CarSharingInvoice {
    identifier: string;
    number: string;
    type: string;
    status: string;
    vatNumber: string;
    firstName: string;
    lastName: string;
    amount: number;
    referenceTime: string;
    draft: boolean;
}

export interface CarSharingInvoicesResponse {
    rows: CarSharingInvoice[];
    total: number;
}

export interface CarSharingPaymentsResponse {
  invoiceReportDatas: CarSharingPaymentReport[];
  invoiceReservationDatas: CarSharingPaymentReservation[];
  reportCsv: string;
  statusCode: string;
  statusMessage: string;
}


export interface CarSharingPaymentsBody {
  invoiceReportDatas: CarSharingPaymentReport[];
  invoiceReservationDatas: CarSharingPaymentReservation[];
  reportCsv: string;
  statusCode: string;
  statusMessage: string;
}


export interface CarSharingPaymentReport {
  contractId: number;
  customerNumber: string;
  firstName: string;
  lastName: string;
  periodFrom: string;
  periodTill: string;
  personId: number;
  rentals: number;
  totalPrice: number;
}


export interface CarSharingPaymentReservation {
  firstname?: string | null;
  lastname?: string;
  personID: number;
  reservationID: number;
  totalPrice: number;
  interopReservation: boolean;
  invoiceID: number;
  invoiceNumber: string;
  invoiceServiceDatas: CarSharingPaymentService[];
  endROPName?: string | null;
  features?: string | null;
  reservationNumber?: string | null;
  reservedFrom?: string | null;
  reservedTill?: string | null;
  rotCaption?: string | null;
  startROPName?: string | null;
  note?: string | null;
}


export interface CarSharingPaymentService {
  canReiterate: boolean;
  carID: number;
  customerFirstname: string;
  customerLastname: string;
  invoiceItemDatas: CarSharingPaymentItem[];
  likelyRefund: number;
  personId: number;
  reservationID: number;
  serviceAuxiliaryText: string;
  serviceClassification: number;
  serviceDateFrom: string;
  serviceDateTill: string;
  serviceID: number;
  serviceTypeCaption: string;
  serviceTypeID: number;
  totalPrice: number;
  unit: string;
  note?: string | null;
  divertUsed?: string | null;
  carModel?: string | null;
  carPlate?: string | null;
  voucherUsed?: string | null;
  serviceValueFrom?: string | null;
  serviceValueTill?: string | null;
  transaction?: string | null;
  executeRefundServiceRequest: CarSharingPaymentRefundRequest;
}


export interface CarSharingPaymentRefundRequest {
  divertName: string;
  divertServiceId: number;
  divertUnit: string;
  unitPrice: string;
}


export interface CarSharingPaymentItem {
  invoiceItemID: number;
  quantity: number;
  serviceID: number;
  taxRate: number;
  text: string;
  totalPrice: number;
  unit: string;
  unitPrice: string;
}

export interface InvoiceServiceRequestFilter {
  languageId?: string;
  definedTime?: string;
  dateInvoiceServiceFrom?: string;
  dateInvoiceServiceTill?: string;
  reservationid?: string;
  contractId?: string[];
  personIds?: string[];
}

export interface PaymentRequestFilter {
  client?: string;
  invoiceServiceRequest?: InvoiceServiceRequestFilter;
  lang?: string;
}



export interface IEditCustomerBaseFieldsParams {
    cbCustomerId?: string,
    bpCode?: string,
    idTenant?: string,
    //oldBpCode: string,
    email?: string,
    cbType?: string,
    dealerType?: string,
    customerType?: string,
    role?: string[],
    language?: string,
    partnerType?: string,
    vip?: string,
    extMgmtReason?: string,
    blacklist?: string,
    blacklistDescription?: string,
    initialRegDate?: string,
    finalRegDate?: string,
    legalForm?: string,
    publicAuthority?: string,
    paIdNumber?: string,
    bpBlocked?: string,
    contactInfo?: {
        prefix?: string | null,
        mobile?: string,
        addresses?: {
            id?: string
            cbCustomerId?: string,
            addressNumber?: string,
            street?: string,
            houseNumber?: string,
            zipCode?: string,
            province?: string,
            city?: string,
            country?: string,
            addrEmail?: string,
            pec?: string,
            addrMobile?: string,
            telephone?: string,
            fax?: string,
            website?: string,
            companyFiscalCode?: string,
            recipientCode?: string,
            addressType?: string
        }[] | []
    },
    registry?: {
        firstName?: string,
        lastName?: string,
        vatNumber?: string,
        taxCode?: string,
        drvLicenceNumber?: string,
        gender?: string,
        birthDate?: string,
        birthCountry?: string,
        birthProvince?: string,
        birthCity?: string,
        vatNumberCountry?: string,
        businessName?: string,
        siren?: string,
        siret?: string
    },
    salesAreas?: {
        id?: string,
        salesOrganization?: string,
        distributionChannel?: string,
        division?: string,
        currency?: string
    }[] | [],
    termsAndCond?: {
        id?: string,
        companyCode?: string,
        termCondType?: string,
        result?: boolean,
        division?: string,
        communicationChannel?: string,
        distributionChannel?: string,
        revocationChannel?: string,
        revocationReason?: string,
        acquisitionDateTime?: string,
        revocationDateTime?: string
    }[] | [],
    paymentInfo?: {
        id?: string,
        buagId?: string,
        paymentMethod?: string,
        paymentTerms?: string,
        correspondingVariant?: string,
        iban?: string,
        accountHolder?: string,
        referenceDetails?: string
    }[] | [],
    corporateInfo?: {
        idZIT019?: string | null,
        salesArea?: string,
        fleet?: string,
        class?: string,
        sizingClass?: string,
        maxRentalNum?: string,
        contactPersons?: {
            id?: string | null,
            //cbCustomerId?: string | null,
            bpCode?: string | null,
            name?: string,
            surname?: string,
            address?: string,
            houseNumber?: string,
            country?: string,
            region?: string,
            city?: string,
            postalCode?: string,
            phoneNumber?: string,
            mobile?: string,
            email?: string,
            delete?: string
        }[] | []
    },
    modifiedLinkedAddresses?: {
        action?: string,
        link?: {
            customerId?: string | null,
            customerIdToLink?: string | null,
        }
    }[]/*,
    documents?: {
        idNumber?: string | null,
        kind?: string,
        issueDate?: string,
        expireDate?: string,
        issuingAuthority?: string,
        category?: string,
        mctcStatus?: string,
        mctcStatusCode?: string,
        mctcStatusMessage?: string,
        mctcValidationStatusTime?: string
    }[] | []*/

    //idpUid: string
}

export interface IBundleInfoRowData {
    field: string,
    ocr: string,
    user: string
}

interface IBundleDocInfo {
    kind: string | null,
    type: string | null,
    firstName: string | null,
    lastName: string | null,
    dateOfBirth: string | null,
    idDocument: string | null,
    issueDate: string | null,
    expireDate: string | null,
    birthMunicipality: string | null,
    birthProvince: string | null,
    licenseCategory: string | null,
    releasedBy: string | null,
    placeOfIssue: string | null
}

export interface IBundleInfoValues {
    step?: string | null,
    ocrInfo?: IBundleDocInfo | null,
    userInfo?: IBundleDocInfo | null,
}

export interface IBundleInfoRowData {
    field: string,
    ocr: string,
    user: string
}

export interface IDossierFormValues {
    owner: string | null,
    identifier: string | null,
    template: string | null,
    status: string | null,
    description: string | null,
    note: string | null,
    origin: string | null,
    originIdentifier: string | null,
    title: string | null,
    attachments: {
        owner: string | null,
        dossier: string | null,
        identifier: string | null,
        number: string | null,
        type: {
            identifier: string | null,
            title: string | null,
            description: string | null,
            kind: string | null,
            fields: {
                title: string | null,
                description: string | null,
                name: string | null,
                type: string | null,
                values: string[] | [],
                tags: string[] | []
            }[],
            pages: string[] | [],
            tags: string[] | []
        } | null
        numOfTypePages: number | null,
        status: string | null,
        issueDate: string | null,
        expireDate: string | null,
        creationTime: number | null,
        updateTime: number | null,
        country: string | null,
        description: string | null,
        note: string | null,
        origin: string | null,
        originIdentifier: string | null,
        title: string | null,
        pages: {
            owner: string | null,
            dossier: string | null,
            attachment: string | null,
            type: string | null,
            status: string | null,
            origin: string | null,
            originIdentifier: string | null,
            note: string | null,
            creationTime: number | null,
            updateTime: number | null
        }[],
        fields: {
            owner?: string | null,
            dossier?: string | null,
            attachment?: string | null,
            type: {
                description: string | null,
                name: string | null,
                title: string | null,
                type: string | null,
                values: string[] | [],
                tags: string[] | []
            },
            value: string | null,
            values: string[] | []
        }[] | [],
        frontPage: string | null,
        backPage: string | null,
        bundleInfo: {
            step?: string | null,
            ocrInfo?: {
                kind: string | null,
                type: string | null,
                firstName: string | null,
                lastName: string | null,
                dateOfBirth: string | null,
                idDocument: string | null,
                issueDate: string | null,
                expireDate: string | null,
                birthMunicipality: string | null,
                birthProvince: string | null,
                licenseCategory: string | null,
                releasedBy: string | null,
                placeOfIssue: string | null
            } | null,
            usrInfo: {
                kind: string | null,
                type: string | null,
                firstName: string | null,
                lastName: string | null,
                dateOfBirth: string | null,
                idDocument: string | null,
                issueDate: string | null,
                expireDate: string | null,
                birthMunicipality: string | null,
                birthProvince: string | null,
                licenseCategory: string | null,
                releasedBy: string | null,
                placeOfIssue: string | null
            } | null
        } | null
    }[]
}

export interface IDocParam {
    owner?: string | null,
    dossier?: string | null,
    identifier?: string | null,
    number?: string | null,
    kindDescription?: string | null,
    kindIdentifier?: string | null,
    kindValue?: string | null,
    dossierTemplateIdentifier?: string | null,
    status?: string | null,
    issueDate?: string | null,
    expireDate?: string | null,
    country?: string | null,
    fields?: {
        owner?: string | null,
        dossier?: string | null,
        attachment?: string | null,
        type?: {
            description?: string | null,
            name?: string | null,
            title?: string | null,
            type?: string | null,
            values?: string[] | [],
            tags?: string[] | []
        },
        value?: string | null,
        values?: string[] | []
    }[] | [],
    pages?: {
        owner?: string | null,
        dossier?: string | null,
        attachment?: string | null,
        type?: string | null,
        status?: string | null,
        origin?: string | null,
        originIdentifier?: string | null,
        creationTime?: number | null,
        updateTime?: number | null,
        note?: string | null
    }[] | [],
    frontPage?: File | null,
    backPage?: File | null,
    isNewFrontPage: boolean | null,
    isNewBackPage: boolean | null
}

export interface IShowFieldsParams {
    showIssueDate: boolean,
    showExpireDate: boolean,
    showBackPage: boolean,
    showAttachmentFields: boolean
}

export interface ICreateAttachmentParams {
    request: {
        attachment?: {
            owner?: string | null,
            identifier?: string | null,
            number?: string | null,
            kind?: string | null,
            title?: string | null,
            issueDate?: string | null,
            expireDate?: string | null,
            origin: string | null,
            originIdentifier: string | null,
            fields?: {
                owner?: string | null,
                value?: string | null,
                type?: {
                    description?: string | null,
                    name?: string | null,
                    title?: string | null,
                    type?: string | null
                }
            }[] | []
        },
        attachmentType?: string | null,
        dossierTemplate?: string | null
    },
    front?: File | null,
    back?: File | null,
    selfie?: File | null
}

export interface IEditAttachmentParams {
    request: {
        country?: string | null,
        creationTime?: number | null,
        description?: string | null,
        dossier?: string | null,
        expireDate?: string | null,
        fields?: {
            attachment?: string | null,
            dossier?: string | null,
            owner?: string | null,
            type?: {
                description?: string | null,
                name?: string | null,
                tags?: string[] | [],
                title?: string | null,
                type?: string | null,
                values?: string[] | []
            },
            value?: string | null,
            values?: string[] | []
        }[] | [],
        identifier?: string | null,
        issueDate?: string | null,
        note?: string | null,
        number?: string | null,
        origin?: string | null,
        originIdentifier?: string | null,
        owner?: string | null,
        pages: {
            attachment?: string | null,
            creationTime?: number | null,
            dossier?: string | null,
            note?: string | null,
            origin?: string | null,
            originIdentifier?: string | null,
            owner?: string | null,
            status?: string | null,
            type?: string | null,
            updateTime?: number | null
        }[],
        status?: string | null,
        title?: string | null,
        type: {
            description?: string | null,
            fields?: {
                description?: string | null,
                name?: string | null,
                tags?: string[] | [],
                title?: string | null,
                type?: string | null,
                values?: string[] | []
            }[] | [],
            identifier?: string | null,
            kind?: string | null,
            pages?: string[] | [],
            tags?: string[] | [],
            title?: string | null
        },
        updateTime?: number | null
    },
    front?: File | null,
    back?: File | null,
    selfie?: File | null
}

export interface ITempAttachmentPage {
    identifier: string,
    type: string,
    frontPage: string | null,
    backPage: string | null
}

export interface IRoleConfigurationFormValues {
    invoicingAddressId?: string | null,
    invoicingCbCustomerId?: string | null,
    invoicingAddressNumber?: string | null,
    invoicingStreet?: string | null,
    invoicingHouseNumber?: string | null,
    invoicingZipCode?: string | null,
    invoicingProvince?: string | null,
    invoicingCity?: string | null,
    invoicingCountry?: string | null,
    invoicingAddrEmail?: string | null,
    invoicingPec?: string | null,
    invoicingAddrMobile?: string | null,
    invoicingTelephone?: string | null,
    invoicingFax?: string | null,
    invoicingWebsite?: string | null,
    invoicingCompanyFiscalCode?: string | null,
    invoicingRecipientCode?: string | null,
    invoicingAddressType?: string | null,
    residenceAddressId?: string | null,
    residenceCbCustomerId?: string | null,
    residenceAddressNumber?: string | null,
    residenceStreet?: string | null,
    residenceHouseNumber?: string | null,
    residenceZipCode?: string | null,
    residenceProvince?: string | null,
    residenceCity?: string | null,
    residenceCountry?: string | null,
    residenceAddrEmail?: string | null,
    residenceAddrMobile?: string | null,
    residenceAddressType?: string | null,
    paymentInfo?: {
        id?: string | null,
        buagId?: string | null,
        paymentMethod?: string | null,
        paymentTerms?: string | null,
        correspondingVariant?: string | null,
        iban?: string | null,
        accountHolder?: string | null,
        referenceDetails?: string | null
    }[] | [],
}

export interface IOSapEnum {
    languages: {
        key: string,
        value: string
    }[],
    partnerTypes: {
        key: string,
        value: string
    }[],
    customerTypes: {
        key: string,
        value: string
    }[],
    roles: {
        key: string,
        value: string
    }[],
    dealerTypes: {
        key: string,
        value: string
    }[],
    vips: {
        key: string,
        value: string
    }[],
    blacklists: {
        key: string,
        value: string
    }[],
    genders: {
        key: string,
        value: string
    }[],
    divisions: {
        key: string,
        value: string
    }[],
    addressTypes: {
        key: string,
        value: string
    }[],
    termCondTypes: {
        key: string,
        value: string
    }[],
    companyCodes: {
        key: string,
        value: string
    }[],
    communicationChannels: {
        key: string,
        value: string
    }[],
    distributionChannels: {
        key: string,
        value: string
    }[],
    revocationChannels: {
        key: string,
        value: string
    }[],
    revocationReasons: {
        key: string,
        value: string
    }[],
    salesOrganizations: {
        key: string,
        value: string
    }[],
    identifications: {
        key: string,
        value: string
    }[],
    paymentMethods: {
        key: string,
        value: string
    }[],
    paymentTerms: {
        key: string,
        value: string
    }[],
    correspondingVariants: {
        key: string,
        value: string
    }[],
    salesAreas: {
        key: string,
        value: string
    }[],
    classes: {
        key: string,
        value: string
    }[],
    sizingClasses: {
        key: string,
        value: string
    }[],
    /*docTypes: {
        key: string,
        value: string
    }[],*/
    consentTypes: {
        key: string,
        value: string
    }[],
    termTypes: {
        key: string,
        value: string
    }[],
    legalForms: {
        key: string,
        value: string
    }[],
    currencies: {
        key: string,
        value: string
    }[],
    dossierStatus: {
        key: string,
        value: string
    }[],
    digitalIdentityStatus: {
        key: string,
        value: string
    }[],
    buagClass: {
        key: string,
        value: string
    }[],
    extMgmtReason: {
        key: string,
        value: string
    }[]
}

export interface MobilePrefix {
    country: string,
    prefix: string
}

export interface IGetProvincesReturn {
    message?: string,
    code?: string,
    data?: {
        country?: string,
        codeProvince?: string,
        description?: string
    }[] | []
}

export interface IGetProvince {
    country: string,
    codeProvince: string,
    description: string
}

export interface IGetCargosPlaceReturn {
    message?: string,
    code?: string,
    data?: {
        codice?: string,
        descrizione?: string,
        provincia?: string,
        dataFineVal?: string | null
    }[] | []
}

export interface IGetCargosPlace {
    codice: string,
    descrizione: string,
    provincia: string,
    dataFineVal: string | null
}

export interface IMapField {
    key: string,
    value: string
}

export interface IMapFieldBoolean {
    key: string,
    value: boolean
}

export interface ICheckDrivingLicenceRequest {
    owner: string,
    dossier: string,
    attachment: string
}

export interface IUpdateDocumentStatusRequest {
    owner: string,
    identifier: string,
    status: string
}

export interface IGetUniqueIDParams {
    taxCode?: string | null,
    drvLicenceNumber?: string | null,
    vatNumber?: string | null,
    email?: string | null,
    partnerType: string
}

export interface ICheckExistenceParams {
    taxCode: string | null,
    drvLicenceNumber: string | null,
    vatNumberCountry: string | null,
    vatNumber: string | null,
    residenceCountry: string | null,
    email: string | null
}

export interface ScoreInfo {
    name: string,
    value: string,
    score: string
}

export interface CBCreationOfProps {
    creationOf?: "person" | "organization" | null
}
export interface CBEditButtonTrigger {
    [key: string]: number,
    cbDetails: number,
    cbPersonalInfo: number,
    cbInvoicingAddress: number,
    salesAreas: number,
    cbPaymentInfo: number,
    cbCorporateInfo: number
}

export interface CBErrorSectionValidation {
    [key: string]: boolean,
    cbDetails: boolean,
    cbPersonalOrganizationInfo: boolean,
    cbInvoicingAddress: boolean,
    salesAreas: boolean,
    cbPaymentInfo: boolean,
    cbCorporateInfo: boolean
}

export interface CBContactPersonFormFields {
    id?: string | null,
    //cbCustomerId?: string | null,
    bpCode?: string | null,
    name: string,
    surname: string,
    address: string,
    houseNumber: string,
    country: string,
    region: string,
    city: string,
    postalCode: string,
    phoneNumber: string,
    mobile: string,
    email: string,
    delete: string
}

export interface CBExtraAddressDeltaFields {
    action: CBExtraAddressAction,
    link: {
        customerId: string | null,
        customerIdToLink: string | null,
    }
}

export interface sapConfCountry {
    legalForms: Array<{ key: string; value: string }>;
    paymentTerms: any[];
}

/* *****************************    Enums    ***************************** */

export enum CBOrigin {
    USER = "USER",
    BACKOFFICE = "BACKOFFICE"
}

export enum CBOriginIdentifier {
    IDM = "IDM",
    CUSTOMERCARE = "CC-"
}

export enum CBOmissionType {
    OMISSION_DASH = "--"
}

export enum CBPartnerType {
    PERSON = "1",
    ORGANIZATION = "2"
}

export enum CBAuth {
    VIEW_PERSON = "SCOPE_VIEW_PERSON_CUSTOMER",
    VIEW_ORGANIZATION = "SCOPE_VIEW_ORGANIZATION_CUSTOMER",
    VIEW_BOOKINGS = "SCOPE_VIEW_CUSTOMER_BOOKINGS",
    VIEW_INVOICES = "SCOPE_VIEW_CUSTOMER_INVOICES",
    VIEW_PAYMENTS = "SCOPE_VIEW_CUSTOMER_PAYMENTS",
    VIEW_RENTAL_AGREEMENTS = "SCOPE_VIEW_CUSTOMER_RENTAL_AGREEMENTS",
    VIEW_FINES = "SCOPE_VIEW_CUSTOMER_FINES",
    VIEW_DAMAGES = "SCOPE_VIEW_CUSTOMER_DAMAGES",
    VIEW_SUBSCRIPTIONS = "SCOPE_VIEW_CUSTOMER_SUBSCRIPTIONS",
    VIEW_VOUCHERS = "SCOPE_VIEW_CUSTOMER_VOUCHERS",
    VIEW_OUTSTANDINGS = "SCOPE_VIEW_CUSTOMER_OUTSTANDINGS",
    WRITE_CUSTOMER = "SCOPE_WRITE_CUSTOMER",
    SCOPE_CREATE_PERSON_CUSTOMER = "SCOPE_CREATE_PERSON_CUSTOMER",
    SCOPE_CREATE_ORGANIZATION_CUSTOMER = "SCOPE_CREATE_ORGANIZATION_CUSTOMER",
    VIEW_CUSTOMER_STATUS_HISTORY = "SCOPE_VIEW_CUSTOMER_STATUS_HISTORY",
    WRITE_CUSTOMER_STATUS = "SCOPE_WRITE_CUSTOMER_STATUS"
}

export enum CBDossierKind {
    LICENCE = "Driving Licence",
    SELFIE = "Selfie",
    IDENTITY_DOCUMENT_PASSPORT = "Passport",
    IDENTITY_DOCUMENT_CARD = "Identity Card",
    INTERNATIONAL_DRIVING_LICENCE = "International Driving Licence",
    INTERNATIONAL_TRANSLATION = "International Translation"
}

export enum CBDossierKindKeys {
    LICENCE = "0000000001",
    SELFIE = "0000000002",
    IDENTITY_DOCUMENT_PASSPORT = "0000000003",
    IDENTITY_DOCUMENT_CARD = "0000000004",
    INTERNATIONAL_DRIVING_LICENCE = "0000000005",
    INTERNATIONAL_TRANSLATION = "0000000006"
}

export enum CBBundleStep {
    DRIVING_LICENCE = "DRIVING_LICENSE",
    IDENTITY_CARD = "IDENTITY_CARD",
    INTERNATIONAL_DRIVING_LICENSE = "INTERNATIONAL_DRIVING_LICENSE",
    INTERNATIONAL_TRANSLATION = "INTERNATIONAL_TRANSLATION",
    PASSPORT = "PASSPORT",
    SELFIE = "SELFIE"
}

export enum CBAddressType {
    RESIDENCE = "RESIDENCE",
    INVOICING = "INVOICING"
}

export enum CBInvoicingCode {
    DEFAULT = "0000000"
}

export enum CBRoleKey {
    DRIVER = "ZIT001",
    PROSPECT = "ZIT008",
    SOLD_TO_PARTY = "CRM000"
}

export enum CBCountry {
    ITALY = "IT",
    SAN_MARINO = "SM",
    FRANCE = "FR",
    SPAIN = "ES",
    PORTUGAL = "PT",
}

export enum CBCountryExtended {
    ITALY = "Italy",
    FRANCE = "France",
    SPAIN = "Spain",
    PORTUGAL = "Portugal",
}

export enum CBGoogleAutocompleteType {
    CITIES = "(cities)",
    ADDRESSES = "address",
    LOCALITY = "locality",
    LOCALITY2 = "administrative_area_level_3",
    PROVINCE = "administrative_area_level_2",
    COUNTRY = "country",
    POSTAL_CODE = "postal_code",
    ROUTE = "route",
    STREET_NUMBER = "street_number"
}

export enum CBPhaseTypes {
    EMAIL = "EMAIL",
    MOBILE = "MOBILE",
    DOC = "DOC"
}

export enum CBAttachmentFieldTypes {
    STRING = "STRING",
    ARRAY_OF_STRING = "ARRAY_OF_STRING",
}

export enum CBAttachmentFieldTypeNames {
    CITIZENSHIP = "Citizenship",
    ISSUE_DATE = "Issue Date",
    ISSUING_AUTHORITY = "Issuing Authority",
    ISSUING_PLACE = "Issuing Place",
    MCTC = "MCTC",
    MCTC_STATUS = "MCTCStatus",
    MCTC_STATUS_TIMESTAMP = "MCTCStatusTimestamp",
    MCTC_STATUS_MESSAGE = "MCTCStatusMessage",
    MCTC_STATUS_CODE = "MCTCStatusCode",
    CATEGORY = "category",
    DE = "DE",
    DNS = "DNS",
    LIVENESS = "Liveness"
}

export enum CBDocumentStatusValue {
    UNDEFINED = "UNDEFINED",
    TO_VALIDATE = "TO_VALIDATE",
    NOT_TO_VALIDATE = "NOT_TO_VALIDATE",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETE = "COMPLETE",
    INCOMPLETE = "INCOMPLETE",
    UPDATED = "UPDATED",
    DELETED = "DELETED",
    EXPIRED = "EXPIRED"
}

export enum Base64MagicNumber {
    JPG_JPEG = "/9j/",
    PNG = "iVBORw0KGgo"
}
export enum CBIntegrationButtonLink {
    BOOKINGS = "/booking/list",
    PAYMENTS = "/finance/payments/payment-request",
    INVOICES = "/finance/invoices",
    RA = "/network/ra-search",
    FINES = "/finessecurity/fines",
    DAMAGES = "/operation/damages/forms",
    SUBSCRIPTIONS = "/salesmarketing/subscriptionContractslist",
    VOUCHERS = "/salesmarketing/voucherlist",
    OUTSTANDING = "/finance/payments/outstanding-management"
}

export enum CBYupTestID {
    TAX_CODE_FORMAT_NOT_VALID_FOR_ORGANIZATION_ON_CREATE = "taxCodeFormatNotValidForOrganizationOnCreate",
    CHECK_REQUIRED_AND_FORMAT_TAX_CODE_FOR_ORGANIZATION_ON_UPDATE = "checkRequiredAndFormatTaxCodeForOrganizationOnUpdate",
    AT_LEAST_ONE_PAYMENT_REQUIRED = "atLeastOnePaymentRequired",
    AT_LEAST_ONE_PAYMENT_REQUIRED_ON_UPDATE = "atLeastOnePaymentRequiredOnUpdate",
    CHECK_VAT_NUMBER = "checkVatNumber",
    CHECK_VAT_NUMBER_ON_UPDATE = "checkVatNumberOnUpdate",
    CHECK_FORMAT_IBAN = "checkFormatIban",
    CHECK_FORMAT_IBAN_ON_UPDATE = "checkFormatIbanOnUpdate",
    CHECK_FORMAT_IBAN_ON_CONFIG = "checkFormatIbanOnConfig",
    AT_LEAST_ONE_CONTACT_PERSON_REQUIRED = "atLeastOneContactPersonRequired",
    AT_LEAST_ONE_CONTACT_PERSON_REQUIRED_ON_UPDATE = "atLeastOneContactPersonRequiredOnUpdate",
    IS_TAX_CODE_REQUIRED_ON_CREATE = "isTaxCodeRequiredOnCreate",
    IS_TAX_CODE_FORMAT_VALID_FOR_PERSON_ON_CREATE = "isTaxCodeFormatValidForPersonOnCreate",
    IS_SIRET_AND_SIREN_COMPLIANT_ON_CREATE = "isSirenAndSiretCompliantOnCreate",
    IS_SIRET_AND_SIREN_COMPLIANT_ON_UPDATE = "isSirenAndSiretCompliantOnUpdate",
    BUAG_SALES_AREA_MARKET_CONSISTENCY_ON_CREATE = "buagSalesAreaMArketConsistencyOnCreate",
    BUAG_SALES_AREA_MARKET_CONSISTENCY_ON_UPDATE = "buagSalesAreaMArketConsistencyOnUpdate",
    IS_SALES_ORGANIZATION_ALLOWED_UNDER_TENANTS = "isSalesOrganizationAllowedUnderTenants"
}

export enum CBLegalFormKey {
    SOCIETA_ESTERA = "SOCIETA_ESTERA",
    ENTE_OSP_ASL = "ENTE_OSP_ASL",
    SOCIETA_ANONIMA = "SOCIETA_ANONIMA",
    ONLUS = "ONLUS",
    ALTRE_FORME_GIU = "ALTRE_FORME_GIU",
    ENTE_PUBBLICO = "ENTE_PUBBLICO",
    ENTE_RELIGIOSO = "ENTE_RELIGIOSO",
    ENTE_MORALE2 = "ENTE_MORALE2",
    ALTRI_ENTI = "ALTRI_ENTI",
    DITTA_INDIVIDUALE = "DITTA_INDIVIDUALE"
}

export enum CBValuableLength {
    TAX_CODE = 16,
    MIN_VAT_NUMBER = 5,
    MAX_ITA_VAT_NUMBER = 11,
    MAX_CONTACT_PERSON_NAME_LENGTH = 20,
    MAX_CONTACT_PERSON_SURNAME_LENGTH = 20,
    SIREN = 9,
    SIRET = 14
}

export enum CBLabel {
    TAX_CODE_LABEL_CHECK = "taxCode",
    DRIVING_LICENCE_LABEL_CHECK = "drvLicence",
    VAT_NUMBER_LABEL_CHECK = "vatNumber",
    EMAIL_LABEL_CHECK = "email"
}

export enum CBCustomerState {
    ACTIVE = "ACTIVE",
    BLOCKED = "BLOCKED",
    SUSPENDED = "SUSPENDED",
    WITHDRAWN = "WITHDRAWN"
}

export const CBCustomerStateId = Object.freeze({
    ACTIVE: 1,
    BLOCKED: 2,
    SUSPENDED: 3,
    WITHDRAWN: 4,
});

export enum CBDossierFilterStatus {
    NO_DOSSIER = "NO_DOSSIER",
    TO_VALIDATE = "TO_VALIDATE",
    INCOMPLETE = "INCOMPLETE",
    UPDATED = "UPDATED",
    VALIDATED = "VALIDATED"
}

export enum CBDigitalIdentityState {
    SUPER_LIGHT = "SUPER_LIGHT",
    LIGHT_PENDING = "LIGHT_PENDING",
    LIGHT = "LIGHT",
    FULL_PENDING = "FULL_PENDING",
    FULL = "FULL"
}

export enum CBSapCode {
    KO_CREATE = "WS04_4000020",
    KO_UPDATE = "WS04_4000021",
}

export enum CBYesNoType {
    NO = "0",
    YES = "1"
}


export enum CBPaymentMethod {
    DIRECT_DEBIT = "DIRECT_DEBIT"
}

export enum CBEditButtonTriggerStatus {
    UNDEFINED = 0,
    TO_UPDATE = 1,
    UPDATED = 2
}

export enum CBCreationPathName {
    CREATE = "create",
    PERSON_CREATE = "person-create",
    ORGANIZATION_CREATE = "organization-create"
}

export enum CBTabIndex {
    CUSTOMER_DETAIL = 0,
    DOSSIER = 1,
    CAR_SHARING = 2,
    CHANGE_LOG = 3
}

// CR-DRIVALIA-EPCH (LPP-22837): riga del change log cliente (mirror del changelog Booking)
export interface CBChangeLogRow {
    id?: number;
    fieldName?: string;
    originalValue?: string;
    newValue?: string;
    operator?: { username?: string; type?: string };
    datetime?: string;
}

export enum CBExtraAddressAction {
    LINK = "1",
    UNLINK = "2"
}

export enum CBTenants {
    ITALY = "drivalia_it",
    FRANCE = "drivalia_fr",
    SPAIN = "drivalia_es",
    PORTUGAL = "drivalia_pt"
}

export enum CBConsentCompanyCode {
    DRIVALIA_ITALY = "Drivalia_Italy",
    DRIVALIA_FRANCE = "Drivalia_France",
    DRIVALIA_SPAIN = "Drivalia_Spain",
    DRIVALIA_PORTUGAL = "Drivalia_Portugal",
}

/* *****************************    Const    ***************************** */

export const NOT_REQUIRED_LEGAL_FORMS: string[] = [
    CBLegalFormKey.SOCIETA_ESTERA,
    CBLegalFormKey.ENTE_OSP_ASL,
    CBLegalFormKey.SOCIETA_ANONIMA,
    CBLegalFormKey.ONLUS,
    CBLegalFormKey.ALTRE_FORME_GIU,
    CBLegalFormKey.ENTE_PUBBLICO,
    CBLegalFormKey.ENTE_RELIGIOSO,
    CBLegalFormKey.ENTE_MORALE2,
    CBLegalFormKey.ALTRI_ENTI,
    ""
];

export const BLANK_OPTION = {
    key: "",
    value: null
}

export const YES_NO_OPTIONS: IMapField[] = [
    {
        key: "N",
        value: "0"
    },
    {
        key: "Y",
        value: "1"
    }
]

export const YES_NO_OPTIONS_BOOL: IMapFieldBoolean[] = [
    {
        key: "N",
        value: false
    },
    {
        key: "Y",
        value: true
    }
]

export const PA_ID_NUMBER_DEFAULT_VALUE = "XXXXXX"

export const LEGAL_FORM_TO_FILTER_KEY = [
    "SPA_01",
    "SRL_02",
    "SAA_03",
    "SAS_04",
    "SRL_&_CO_SAS_05",
    "SOCDIRCIVILE_07",
    "CO_LTD_08",
]

export const CB_BUNDLE_STEP_DOSSIER_KIND_MAP: IMapField[] = [
    {
        key: CBBundleStep.DRIVING_LICENCE,
        value: CBDossierKindKeys.LICENCE
    },
    {
        key: CBBundleStep.PASSPORT,
        value: CBDossierKindKeys.IDENTITY_DOCUMENT_PASSPORT
    },
    {
        key: CBBundleStep.IDENTITY_CARD,
        value: CBDossierKindKeys.IDENTITY_DOCUMENT_CARD
    },
    {
        key: CBBundleStep.SELFIE,
        value: CBDossierKindKeys.SELFIE
    }/*,
    {
        key: CBBundleStep.INTERNATIONAL_DRIVING_LICENCE,
        value: ?
    },
    {
        key: CBBundleStep.INTERNATIONAL_TRANSLATION,
        value: ?
    }*/
]

export const IT_FISCAL_CODE_FORMAT_REGEX = RegExp(/^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/);
export const ES_FISCAL_CODE_FORMAT_REGEX = RegExp(/^([A-Z]\d{7}[A-Z0-9]|\d{8}[A-Z]|[XYZ]\d{7}[A-Z])$/);
export const PT_FISCAL_CODE_FORMAT_REGEX = RegExp(/^\d{9}$/);
export const VALID_GENERIC_FORMAT_IBAN_REGEX = RegExp(/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/);
export const VALID_IT_SM_FORMAT_IBAN_REGEX = RegExp(/^[IT|SM]{2}[0-9]{2}[A-Z]{1}[A-Z0-9]{22}$/);
export const VALID_SIRET_FORMAT_REGEX = RegExp(/^[0-9]{14}$/);
export const DELETE_SYMBOL = "X";
export const REGISTRY_PHASE_WAITING_FOR_VALIDATION = "WAITING_FOR_VALIDATION";
export const UPDATE_SUCCESS_WITH_EXTRA_ADDRESS_PROBLEM_CODE = "WS04_4040003";

export const DOSSIER_ATTACHMENT_FIELD_SORT_ORDER = [CBAttachmentFieldTypeNames.CATEGORY, CBAttachmentFieldTypeNames.ISSUE_DATE, CBAttachmentFieldTypeNames.CITIZENSHIP, CBAttachmentFieldTypeNames.ISSUING_PLACE, CBAttachmentFieldTypeNames.ISSUING_AUTHORITY, ''];
export const DOSSIER_ATTACHMENT_CONFIG_FIELD_TO_EXCLUDE = ["MCTCStatus", "MCTCStatusCode", "MCTCStatusMessage", "MCTCStatusTimestamp", "DE Score", "DNS Score", "DE Value", "DNS Value", "Liveness Score", "Liveness Value"];